module.exports = __webpack_public_path__ + "img/echo-full.e7caaa1b.png";